<template>
  <div class="nix-login-page">
    <div class="nix-login-theme-toggle">
      <ToggleTheme />
    </div>

    <section class="nix-login-left">
      <div class="nix-login-content">
        <div class="nix-login-logo">
          <img src="https://espaco.blob.core.windows.net/nixloc-imagens/nixloc.svg" alt="Nixloc" />
        </div>

        <Messages />

        <transition name="fade" mode="out-in">
          <LoginForm v-if="!showForgotPassword" key="login" @forgot-password="showForgotPassword = true" @login-success="onLoginSuccess" />
          <LoginForgotPassword v-else key="forgot" @back-to-login="showForgotPassword = false" />
        </transition>
      </div>
    </section>

    <LoginImage class="nix-login-right" />
  </div>
</template>

<script>
import ToggleTheme from '@/ui/shared/ToggleTheme.vue'
import Messages from '@/ui/shared/Messages.vue'
import LoginForm from '@/modules/auth/components/LoginForm.vue'
import LoginForgotPassword from '@/modules/auth/components/LoginForgotPassword.vue'
import LoginImage from '@/modules/auth/components/LoginImage.vue'
import { buildMenuItens } from '@/modules/auth/utils/menu-loader'
import { encodeHandoff } from '@/modules/auth/utils/handoff'
import { mapMutations } from 'vuex'

export default {
  name: 'AuthLoginView',
  components: { ToggleTheme, Messages, LoginForm, LoginForgotPassword, LoginImage },
  data() {
    return {
      showForgotPassword: false,
    }
  },
  methods: {
    ...mapMutations('user', ['addUserLogged', 'addItemMenu', 'removeItemMenu']),
    onLoginSuccess({ content }) {
      const nixlocWebUrl = String(process.env.VUE_APP_NIXLOC_WEB_URL || '').replace(/\/+$/, '')

      if (content && content.beta && nixlocWebUrl) {
        window.location.replace(nixlocWebUrl + '/sso#s=' + encodeHandoff(content))
        return
      }

      this.signIn(content)
    },
    async signIn(content) {
      await this.$store.dispatch('auth/setAuthData', content)
      this.addUserLogged(content)
      this.removeItemMenu()
      this.addItemMenu(buildMenuItens(content.user.rules))
      this.$router.replace('/dashboard')
    },
  },
}
</script>

<style scoped>
.nix-login-page {
  position: fixed;
  inset: 0;
  display: flex;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background: var(--bg-page);
}

.nix-login-theme-toggle {
  position: absolute;
  top: 16px;
  right: 16px;
  z-index: 10;
}

.nix-login-left {
  flex: 0 0 38%;
  min-width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  overflow-y: auto;
  background: var(--bg-base);
}

.nix-login-content {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.nix-login-logo {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
}

.nix-login-logo img {
  width: 70%;
  max-width: 120px;
  height: auto;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

@media (max-width: 900px) {
  .nix-login-right { display: none; }
  .nix-login-left { flex: 1 1 100%; }
}

@media (max-width: 480px) {
  .nix-login-left { padding: 16px; }
  .nix-login-content { max-width: 100%; }
}
</style>
